// This file is used for maintain and manage API services.
(function () {
  'use strict';
  angular.module('obex').
  factory('members', ['$http', 'obexConstant', 'authService',
    ($http, obexConstant, authService) => {
		 let showAll = false;
      return {  
		setShowAll(showAllAgents) {          
          showAll =  showAllAgents;
        },
        getShowAll() {
          return showAll;
        },
        getMembersByAdmin(includeAllMembers = false) {
          const url = obexConstant.urlAccount+'/admin/'+includeAllMembers;
          return authService.getAuthorizationHeader().then(authHeader => {
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getTravelManagers(organizationId) {
          const url = `${obexConstant.urlTravelManagerOrganizations}/members/travelmanagers/organization/${organizationId}`;
          return authService.getAuthorizationHeader().then(authHeader => {
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getMembers() {
          return authService.getAuthorizationHeader().then(authHeader => $http.get(obexConstant.urlAccount, {
            headers: authHeader,
          }));
        },
        getAllAgentsByAdmin(travelAgencyId) {
          const url = `${obexConstant.urlBaseUrl}v2/members/admin/travelagencyid/${travelAgencyId}/true`
          return authService.getAuthorizationHeader().then(authHeader => {
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        gerMemberAccount(email) {
          const url = `${obexConstant.urlAccount}/email/${email}`;
          return authService.getAuthorizationHeader().then(authHeader => $http.get(url, {
            headers: authHeader,
          }));
        },

        changePassword(id, member) {
          const url = `${obexConstant.urlAccount}/changepassword/${id}`;
          return authService.getAuthorizationHeader().then(authHeader => $http.put(url, member, {
            headers: authHeader,
          }));
        },

        getMemberById(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}/${id}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        getMembersByOrgId(orgId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}/supportedusers/${orgId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        deleteAccount(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}/${id}`;
            return $http.delete(url, {
              headers: authHeader,
            });
          });
        },

        setAdmin(id, isAdmin) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}/setadmin/${id}/${isAdmin}`;
            return $http.put(url, null, {
              headers: authHeader,
            });
          });
        },

        setEnableDisableAccount(id, enable) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}/enableAccount/${id}`;
            return $http.put(url, null, {
              headers: authHeader,
            });
          });
        },

        updateName(id, member) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}/updatename/${id}`;
            const putData = {
              Id: member.Id,
              FirstName: member.FirstName,
              LastName: member.LastName,
            };
            return $http.put(url, putData, {
              headers: authHeader,
            });
          });
        },

        saveAgent(member) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}`;
            return $http.post(url, member, {
              headers: authHeader,
            });
          });
        },
      };
    },
  ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/members.service.js